import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/secure/$')({
  beforeLoad: ({ params }) => {
    const newPath = `/${params._splat}`;
    throw redirect({ replace: true, statusCode: 301, to: newPath });
  },
});
